export enum HasAdjustments{
    HasAdjustments = 'Has Adjustments',
    NoAdjustments = 'No Adjustments'
}